export const countries = [
  { value: 'en', label: 'English (UK)', nationalName: 'English (UK)' },
  { value: 'de', label: 'German (Germany)', nationalName: 'Deutsch' },
  { value: 'fr', label: 'French (France)', nationalName: 'Français' },
  { value: 'pt', label: 'Portuguese (Portugal)', nationalName: 'Portuguese' },
  { value: 'es', label: 'Spanish (Spain)', nationalName: 'Español' },
  { value: 'sv', label: 'Swedish', nationalName: 'Svenska' },
  { value: 'da', label: 'Danish', nationalName: 'Dansk' },
  { value: 'fi', label: 'Finnish', nationalName: 'Suomi' },
  { value: 'it', label: 'Italian', nationalName: 'Italiano' },
  { value: 'nl', label: 'Dutch (Netherlands)', nationalName: 'Nederlands' },
  { value: 'pl', label: 'Polish', nationalName: 'Polski' },
  { value: 'ro', label: 'Romanian', nationalName: 'Română' },
  { value: 'sq', label: 'Albanian', nationalName: 'Shqip' },
];
